import styled from '@emotion/styled';

export const StyledHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1 {
    font-size: 2.3077rem;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    letter-spacing: 0.0385rem;
  }
`;
